import {useEffect} from 'react'
import {repeatStore} from './repeat-store'

export const useHighlightUpdater = () => {
  useEffect(() => {
    let handler: TimeoutHandler
    if (repeatStore.state.highlighted) {
      handler = setTimeout(() => repeatStore.setHighlighted(undefined), 2000)
    }
    return () => {
      clearTimeout(handler)
    }
  }, [repeatStore.state.highlighted])
}
